<template>
  <div class="pesquisa-drawer-wrapper">
    <div v-if="showModel && !isHorizons" class="manual-overlay"></div>
    <el-drawer
      :model-value="showModel"
      class="drawer-pesquisa"
      direction="rtl"
      destroy-on-close
      :append-to-body="defineAppendToBody"
      :show-close="false"
      :with-header="false"
      :size="560"
      :close-on-click-modal="false"
      style="
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        z-index: 1032;
      "
      small-title
    >
      <div
        class="drawer-pesquisa__content"
        style="width: auto; height: 100%; padding: 0 1.5rem"
      >
        <vc-material-icon
          class="close"
          icon="close"
          style="
            position: absolute;
            right: 10px;
            top: 10px;
            z-index: 1;
            cursor: pointer;
            font-size: 22px;
          "
          @click="handleClose"
        />
        <img
          :src="blobImage"
          alt="blob"
          class="blob"
          style="position: absolute; top: 0; right: 0; z-index: 0"
        />
        <component
          :is="defineComponent"
          @enviar="enviar"
          @close="close"
          :concluido="concluido"
          :loading="loading"
          style="width: auto; height: 100%; z-index: 1"
        />
        <img
          :src="dotsImage"
          alt="dots"
          class="dots"
          style="position: absolute; bottom: 3px; left: 5px; z-index: 0"
        />
      </div>
    </el-drawer>
  </div>
</template>

<script setup lang="ts">
import blobImage from "./assets/blob.png";
import dotsImage from "./assets/dots.png";
import { diContainer } from "@/inversify.config";
import { computed, onMounted, onUnmounted, ref } from "vue";
import {
  EPesquisasDrawer,
  PesquisaDrawerGateway,
  PesquisaDrawerGatewayDi
} from "./services/ports/PesquisaDrawerGateway";
import AntecipaPopUp from "./pesquisas/AntecipaPopUp.vue";
import { IToastNotification } from "@/core/composables/notification/types";
import { DITypes, DIValidators } from "@/core/@types/types";
import { pesquisaDrawerContainer } from "./container/pesquisaDrawerContainer";
import { IF360Validator } from "@/core/validators/F360Validator";

diContainer.load(pesquisaDrawerContainer);

const loading = ref(false);
const concluido = ref(false);
const defineAppendToBody = ref(false);
const showModel = ref(false);

const pesquisaDrawerGateway = diContainer.get<PesquisaDrawerGateway>(
  PesquisaDrawerGatewayDi
);

const notification = diContainer.get<IToastNotification<string>>(
  DITypes.NOTIFICATION
);

const sysAdminValidator = diContainer.get<IF360Validator>(
  DIValidators.SYS_ADMIN
);

const tipo = ref<EPesquisasDrawer | undefined>(EPesquisasDrawer.AntecipaPopUp);

const currentPath = window.location.href;
const isHorizons = currentPath.includes("/v2/") || currentPath.includes("/#/");

const MappedComponents = {
  [EPesquisasDrawer.AntecipaPopUp]: AntecipaPopUp
};

const defineComponent = computed(() => {
  if (!tipo.value) return undefined;

  if (MappedComponents[tipo.value]) return MappedComponents[tipo.value];

  return undefined;
});

const obterPesquisas = async () => {
  try {
    loading.value = true;

    const pesquisaDrawer = await pesquisaDrawerGateway.obterPesquisaDrawer();

    const obterCampanhaAtiva = pesquisaDrawer?.result?.find(
      (campanha) => campanha.ativo
    );

    if (!obterCampanhaAtiva) return;

    showModel.value = true;

    tipo.value = obterCampanhaAtiva?.nome;
  } finally {
    loading.value = false;
  }
};

const close = async () => {
  try {
    if (!tipo.value) {
      showModel.value = false;

      return;
    }

    await pesquisaDrawerGateway.enviar(tipo.value, {
      value: {
        tipo: "6",
        descricao: ""
      }
    });
  } finally {
    showModel.value = false;
  }
};

const handleClose = () => {
  close();
};

const enviar = async (form: unknown) => {
  const tipoForm = tipo?.value ? (tipo?.value as EPesquisasDrawer) : undefined;

  if (!tipoForm) return;

  try {
    loading.value = true;
    const response = await pesquisaDrawerGateway.enviar(tipoForm, form);

    if (!response) {
      notification.showNotification(
        "Ocorreu um erro ao enviar a pesquisa, tente novamente mais tarde.",
        {
          type: "error"
        }
      );
      loading.value = false;

      return;
    } else {
      concluido.value = true;
    }
  } catch (error) {
    console.error(error);
  } finally {
    loading.value = false;
  }
};

onMounted(() => {
  if (isHorizons) {
    defineAppendToBody.value = true;
  }
  if (!sysAdminValidator.handleValidation()) {
    obterPesquisas();
  }
});

onUnmounted(() => {
  diContainer.unload(pesquisaDrawerContainer);
});
</script>

<style lang="scss">
@use "element-plus/theme-chalk/el-drawer.css";

.pesquisa-drawer-wrapper {
  .drawer-pesquisa {
    .financas-drawer__header {
      border-bottom: none;
      padding: 0 !important;
    }
  }

  .manual-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1031;
  }
}
</style>
